export class SelectListItemModel {

    constructor(_text: string, _value: string) {
        this.text = _text;
        this.value = _value;
    }

    public disabled: boolean;
    public selected: boolean;
    public text: string;
    public value: string;
}
